import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import dayjs from 'dayjs';

Vue.use(Router);

// Pages
const Page404 = () => import('@/pages/Page404')
const LoginWrapper = () => import('@/pages/Account/LoginWrapper')

const loginCheck = async (to, from, next) => {
  if (!store.getters.isLoggedIn) {
    console.log('loginredir')
    store.dispatch('loginRedirect')
    return;
  } else if (store.getters.isLoggedIn && !store.getters.isConnected) {
    store.commit('SOCKET_CONNECT');
  }
  next();
};

const dashboardRedirect = async (to, from, next) => {
  await loginCheck(to, from, next)
  let orgs = store.getters.userClientHashList
  const orgCount = orgs.length > 0 ? orgs.split(',').length : 0
  const currentUnformattedTime = dayjs()
  const fromTime = currentUnformattedTime.unix() - 3600000
  const toTime = currentUnformattedTime.unix()
  if (orgCount === 1) {
    next(`/organisation-dashboard?f=${fromTime}&t=${toTime}&c=${orgs}`)
  }
}

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "default" */'@/containers/TheContainer'),
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "dashboard" */'@/pages/Dashboard'),
          beforeEnter: dashboardRedirect,
        },
        {
          path: '/my-details',
          name: 'My Details',
          component: () => import(/* webpackChunkName: "mydetails" */'@/pages/Account/MyDetails'),
          beforeEnter: loginCheck,
        },
        {
          path: '/organisation-dashboard',
          name: 'Organisation Dashboard',
          component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "organisation-dashboard" */'@/pages/OrganisationDashboard/OrganisationDashboard.vue'),
        },
        {
          path: '/orgs',
          name: 'Organisation Management',
          component: () => import(/* webpackChunkName: "orgs" */'@/pages/Organisations/Organisations.vue'),
          beforeEnter: loginCheck,
        },
        {
          path: '/interface-events',
          name: 'Interface events',
          component: () => import(/* webpackChunkName: "interface" */'@/pages/InterfaceEvents/InterfaceEvents.vue'),
          beforeEnter: loginCheck,
        },
        {
          path: '/orgs/add',
          meta: {
            type: 'add',
          },
          name: 'New Organisation',
          beforeEnter: loginCheck,
          component: () => import(/* webpackChunkName: "addOrgs" */'@/components/Organisations/AddNewOrg.vue'),
        },
        {
          path: '/orgs/edit/:id',
          meta: {
            type: 'edit',
          },
          name: 'Edit Organisation',
          beforeEnter: loginCheck,
          component: () => import(/* webpackChunkName: "editOrg" */'@/components/Organisations/OrgForm.vue'),
        },
        {
          path: '/events-log',
          name: 'Events Log',
          component: () => import(/* webpackChunkName: "events-log" */'@/pages/Events/Events.vue'),
          beforeEnter: loginCheck,
        },
        {
          path: '/users',
          name: 'User Management',
          component: () => import( /* webpackChunkName: "users" */'@/pages/Users/Users.vue'),
          beforeEnter: loginCheck,
        },
        {
          path: '/status',
          name: 'Status',
          component: () => import( /* webpackChunkName: "status" */'@/pages/Status/Status.vue'),
        },
        {
          path: '/users/add',
          name: 'Add New User',
          component: () => import( /* webpackChunkName: "users" */'@/components/Users/AddNewUser.vue'),
          beforeEnter: loginCheck,
        },
        {
          path: '/build',
          name: 'Apps',
          component: () => import( /* webpackChunkName: "buildapps" */'@/pages/Build/Build.vue'),
        },
        {
          path: 'editinterface',
          name: 'Edit Interface',
          component: () => import( /* webpackChunkName: "editinterface" */'@/pages/Build/EditInterface/EditInterface.vue'),
        },
        {
          path: 'editenv',
          name: 'Edit Environment',
          component: () => import( /* webpackChunkName: "editenv" */'@/pages/Build/EditEnv/EditEnv.vue'),
        },
        {
          path: '/style-guide',
          name: 'Style Guide',
          component: () => import( /* webpackChunkName: "style-guide" */'@/pages/StyleGuide.vue'),
        },
      ],
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: 'login',
          name: 'Login',
          component: LoginWrapper,
          beforeEnter: (to, from, next) => {
            store.commit('SOCKET_DISCONNECT');
            next();
          }
        },
        {
          path: 'reset/:hash',
          name: 'AccountReset',
          component: () => import(/* webpackChunkName: "reset" */'@/pages/Account/ResetPasswordForm.vue')
        },
        {
          path: 'forgot',
          name: 'AccountForgot',
          component: () => import(/* webpackChunkName: "forgot" */'@/pages/Account/ResetPassword.vue')
        },
      ],
    },
    {
      path: '/activate',
      name: 'Activate',
      component: () => import(/* webpackChunkName: "registration" */'@/pages/Register/Activate.vue'),
    },
    {
      path: '*',
      redirect: '/pages/404',
    },
  ]
})
